import TR from 'utils/TR';
import Header from 'components/header';
import T from 'utils/T';
import ex from 'utils/ex';
import ReportTabs from '../ReportTabs';
import InsulinSummary from './InsulinSummary';
import InsulinPattern from './InsulinPattern';
import InsulinStatistics from './InsulinStatistics';
import PageContent from '../../PageContent';
import VBox from 'components/common/VBox';
import Division from 'components/common/Division';
import PageTitle from '../../PageTitle';
import Segment from 'components/common/Segment';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import InsulinRatio from './InsulinRatio';
import InsulinAnalysis from './InsulinAnalysis';

import './ReportInsulin.css';
import GuideButton from '../GuideButton';

import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import React from 'react';
import useReportInsulin from 'hooks/communication/useReportInsulin';
import { useSignal } from 'modules/Signals';

export default function ReportInsulin(props) {
  const {
    renderAll,
    front,
    ...rest
  } = props;

  const {
    requestReportInsulin,
  } = useReportInsulin();

  const signal = useSignal();
  // const [insulin_data, setInsulinData] = React.useState({});
  const [data, setData] = Recoil.useRecoilState(AppStore.assets.data('ReportInsulin'));

  const period_start = Recoil.useRecoilValue(AppStore.assets.period_start);
  const period_end = Recoil.useRecoilValue(AppStore.assets.period_end);
  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  React.useEffect(() => {
    requestReportInsulin({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
    }, (success, data) => {
      if (success) {
        setData(() => data);
      } else {
        setData(() => ({}));
      }
    });
  }, [patient_no, period_end, period_start, requestReportInsulin, setData, signal]);

  React.useEffect(() => {
    if (!front) return;
    signal('ReportData', data, 'ReportInsulin');
  }, [front, data, signal]);

  return (
    <div {...ex(['Page', 'ReportInsulin'], rest)}>
      <PageContent>
        <VBox full>
          <Division>
            <InsulinSummary {...{ insulin_data: data }} />
          </Division>
          <Segment {...{ direction: DIRECTION_VERTICAL }}>
            <InsulinRatio {...{ insulin_data: data, duration: renderAll ? 0 : 1 }} />
          </Segment>
          <Segment {...{ direction: DIRECTION_VERTICAL }}>
            <InsulinAnalysis {...rest} />
          </Segment>
          <Segment {...{ direction: DIRECTION_VERTICAL }}>
            <InsulinPattern {...rest} {...{ duration: renderAll ? 0 : 1 }} />
          </Segment>
          <Segment {...{ direction: DIRECTION_VERTICAL }}>
            <InsulinStatistics {...rest} {...{ duration: renderAll ? 0 : 1 }} />
          </Segment>
          <GuideButton {...rest} {...{ type: 'insulin' }} />
        </VBox>
      </PageContent>
    </div>
  );
}
